<template>
  <div class="bq-container">
    <van-question-steam
      v-if="!(exercise.image === '' && !exercise.title && ((isDone && isExam) || isPrint))"
      :exercise="exercise" />
    <div class="bq-wrap">
        <span v-if="isShowNumber">{{index + 1}}、</span>
        <span v-for="(exercise, index) in mExercise" :key="index">
          <template v-if="exercise.isHollow">
            <van-blank-input v-model="exercise.youAnswer"
                            ref="input"
                            :answer="handlerMultipleAnswer(exercise)"
                            :you-answer="exercise.youAnswer"
                            :index="exercise.inputIndex"
                            :is-active="activeIndex === exercise.inputIndex"
                            :is-done="isDone"
                            :is-right="blanks[exercise.inputIndex].isRight"
                            :is-disable="isPrint || (exercise.isAgain && exercise.isRight)"
                            @input="handleChange(exercise.inputIndex, exercise.youAnswer)"
                            @focus="handleFocus"
                            @enter="handleEnter"
                            @delete="prevFocus" />
          </template>
          <template v-else><span v-html="exercise.text"></span></template>
        </span>
    </div>
    <p v-if="isDone && exercise.explain && isShowExplain" class="explain">
      <strong>解析：</strong>
      <span v-html="exercise.explain"></span>
    </p>
  </div>
</template>

<script>
import utils from '@/services/utils';
import VanBlankInput from '@/components/quizzes/hk/BlankInput.vue';
import VanQuestionSteam from '@/components/common/QuestionSteam.vue';

const PICK_ANSWER = /(\[\[[^\]]*]])/; // 包含符号
// const PICK_ANSWER2 = /(?<=\[\[)[^\]]*(?=]])/g; // 不包含符号

export default {
  props: {
    exercise: {
      type: Object,
      default: () => {},
    },
    isDone: {
      type: Boolean,
      default: false,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
    isShowExplain: {
      type: Boolean,
      default: false,
    },
    isShowNumber: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    userAnswer: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VanBlankInput,
    VanQuestionSteam,
  },
  data() {
    return {
      mExercise: [],
      groups: {},
      activeIndex: 0, // first default focus
    };
  },
  computed: {
    blanks() {
      return this.mExercise.filter(exercise => exercise.isHollow);
    },
    noAnswerIndex() {
      let position = -1;
      this.blanks.some((exercise, index) => {
        position = index;
        return !exercise.youAnswer;
      });
      return position;
    },
    answer() {
      const answerList = this.blanks.map(exercise => exercise.youAnswer);
      if (answerList.some(answer => answer)) {
        return this.blanks.map(exercise => utils.toCDB(exercise.youAnswer));
      }
      return [];
    },
    isRight() {
      return this.blanks.every(item => item.isRight);
    },
    isComplete() {
      return this.blanks.every(exercise => exercise.youAnswer);
    },
    isLastInput() {
      return this.activeIndex >= this.blanks.length - 1;
    },
    isFirstInput() {
      return !this.activeIndex;
    },
  },
  watch: {
    exercise: {
      handler() {
        // clear input value
        this.reset();
        // format data
        this.formatExercise();
        this.initUserAnswer();
      },
      immediate: true,
    },
    isDone: {
      handler() {
        if (this.isDone) {
          this.blanks.forEach((blank, index) => {
            this.verifyAnswer(index, blank.youAnswer);
          });
          this.$emit('change', {
            isRight: this.isRight,
            answer: this.answer,
            isComplete: this.isComplete,
          });
          const groupKeys = Object.keys(this.groups);
          groupKeys.forEach((key) => {
            const groupBlanks = this.blanks.filter(item => item.groupId === key && !item.isRight);
            const noMatchGroup = this.groups[key].filter(item => item.site < 0);
            groupBlanks.forEach((item, index) => {
              item.answer = noMatchGroup[index].value;
            });
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    this.initUserAnswer();
  },
  methods: {
    initUserAnswer() {
      if (this.isDone
        && this.isExam
        && this.userAnswer
        && this.userAnswer.answer
        && this.userAnswer.answer.length
      ) {
        this.userAnswer.answer.forEach((item, index) => {
          this.verifyAnswer(index, item);
        });
      } else if (this.exercise.userAnswer && this.exercise.userAnswer.length) {
        this.exercise.userAnswer.forEach((item, index) => {
          this.verifyAnswer(index, item);
        });
        if (this.exercise.isAgain) {
          this.$nextTick(() => {
            // 聚焦第一个错的
            this.activeIndex = utils.Array.findIndex(this.blanks, { isRight: false }, 'isRight');
          });
          // 将错的设置为空 重新作答
          this.blanks.forEach((item) => {
            if (item.isRight === false) {
              item.youAnswer = '';
            }
          });
          this.$nextTick(() => {
            // 更新blank的值
            this.$refs.input.forEach((item) => {
              item.syncValue();
            });
          });
        }
      }
    },
    handleChange() {
      /* eslint-disable no-lonely-if */
      if (this.isPrint) return;
      this.$emit('change', {
        isRight: this.isRight,
        answer: this.answer,
        isComplete: this.isComplete,
      });
    },
    handlerMultipleAnswer(exercise) {
      if (typeof exercise.answer === 'string') {
        return exercise.answer.replace(/^@/, '');
      }
      let answer;
      for (let i = 0; i < exercise.answer.length; i += 1) {
        const item = exercise.answer[i];
        if (/^@/.test(item)) {
          if (utils.toNumber(item.replace(/^@/, '')) === utils.toNumber(exercise.youAnswer)) {
            answer = item;
          }
        } else if (utils.toNumber(item.toUpperCase())
          === utils.toNumber(exercise.youAnswer.toUpperCase())) {
          answer = item;
        }
      }
      if (!answer) {
        const [first] = exercise.answer;
        answer = first;
      }
      return answer.replace(/^@/, '');
    },
    handlerUserAnswer(inputIndex) {
      if (this.userAnswer) {
        if (!this.userAnswer.answer) return '';
        return this.userAnswer.answer[inputIndex] || '';
      }
      if (this.exercise.userAnswer) {
        return this.exercise.userAnswer[inputIndex] || '';
      }
      return '';
    },
    verifyAnswer(index, value) {
      const blank = this.blanks[index];
      const { groupId } = blank;
      // 处理有组的情况
      if (groupId) {
        const groups = this.groups[groupId];
        for (let i = 0; i < groups.length; i += 1) {
          const group = groups[i];
          if (group.site < 0) {
            // @ 为区分大小写模式
            if (utils.Array.findIndex(groups, { site: index }, 'site') > -1) break;
            // 处理多种答案
            if (utils.isArray(group.value)) {
              let answer;
              // const answer = utils.Array.find(blank.answer, value);
              group.value.forEach((item) => {
                // @ 为区分大小写模式
                if (/^@/.test(item)) {
                  if (utils.toNumber(item.replace(/^@/, '')) === utils.toNumber(value)) {
                    answer = value;
                  }
                } else if (utils.toNumber(item.toUpperCase())
                  === utils.toNumber(value.toUpperCase())) {
                  answer = value;
                }
              });
              if (answer) {
                blank.isRight = true;
                blank.answer = group.value;
                group.site = index;
                break;
              } else {
                blank.isRight = false;
              }
            } else if (/^@/.test(group.value)) {
              if (utils.toNumber(group.value.replace(/^@/, '')) === utils.toNumber(value)) {
                blank.isRight = true;
                blank.answer = group.value;
                group.site = index;
                break;
              }
            } else if (utils.toNumber(group.value.toLocaleUpperCase())
              === utils.toNumber(value.toLocaleUpperCase())) {
              blank.isRight = true;
              blank.answer = group.value;
              group.site = index;
              break;
            }
          }
        }
      } else {
        // 处理多种答案
        if (utils.isArray(blank.answer)) {
          let answer;
          // const answer = utils.Array.find(blank.answer, value);
          blank.answer.forEach((item) => {
            // @ 为区分大小写模式
            if (/^@/.test(item)) {
              if (utils.toNumber(item.replace(/^@/, '')) === utils.toNumber(value)) {
                answer = value;
              }
            } else if (utils.toNumber(item.toUpperCase()) === utils.toNumber(value.toUpperCase())) {
              answer = value;
            }
          });
          if (answer) {
            blank.isRight = true;
          } else {
            blank.isRight = false;
          }
        } else {
          // @ 为区分大小写模式
          if (/^@/.test(this.blanks[index].answer)) {
            if (utils.toNumber(this.blanks[index].answer.replace(/^@/, '')) === utils.toNumber(value)) {
              this.blanks[index].isRight = true;
            } else {
              this.blanks[index].isRight = false;
            }
          } else if (utils.toNumber(this.blanks[index].answer.toUpperCase())
            === utils.toNumber(value.toUpperCase())) {
            this.blanks[index].isRight = true;
          } else {
            this.blanks[index].isRight = false;
          }
        }
      }
    },
    handleFocus(index) {
      if (this.isPrint) return;
      this.activeIndex = index;
    },
    handleEnter() {
      if (this.isPrint) return;
      if (!this.isLastInput) {
        this.nextFocus();
      } else if (this.noAnswerIndex !== -1) {
        this.activeIndex = this.noAnswerIndex;
      }
    },
    analyze() {
      this.blanks.forEach((blank, index) => {
        this.verifyAnswer(index, blank.youAnswer);
      });
      this.$emit('change', {
        isRight: this.isRight,
        answer: this.answer,
        isComplete: this.isComplete,
      });
    },
    prevFocus() {
      if (this.isFirstInput) return;
      if (this.exercise.isAgain) {
        // 寻找上一个未作答的blank
        for (let i = this.activeIndex - 1; i >= 0; i -= 1) {
          const blank = this.blanks[i];
          if (!blank.isRight) {
            this.activeIndex = i;
            break;
          }
        }
      } else {
        this.activeIndex -= 1;
      }
    },
    nextFocus() {
      if (this.isLastInput) return;
      if (this.exercise.isAgain) {
        // 寻找下一个未作答的blank
        for (let i = this.activeIndex + 1; i < this.blanks.length; i += 1) {
          const blank = this.blanks[i];
          if (!blank.isRight) {
            this.activeIndex = i;
            break;
          }
        }
      } else {
        this.activeIndex += 1;
      }
    },
    reset() {
      this.activeIndex = -1; // 解决同一组件实例，无焦点问题
      this.groups = [];
      this.$nextTick(() => {
        this.activeIndex = 0;
      });
    },
    formatExercise() {
      let inputIndex = -1;
      if (!this.exercise.text) {
        /* eslint-disable no-throw-literal */
        throw 'exercise text is null';
      }
      this.exercise.text = this.exercise.text.replace(/\n/g, '<br />');
      this.mExercise = this.exercise.text.split(PICK_ANSWER).map((item) => {
        const isHollow = PICK_ANSWER.test(item);
        const answer = utils.toCDB(item.trim()).replace(/[[\]]/g, '').replace(/\s/g, '').split('||');
        let groupId;
        let multipleAnswer;
        if (answer[0].match(/#\d+#/)) {
          const [key] = answer[0].match(/#\d+#/);
          if (answer.length < 2) {
            const [first] = answer;
            multipleAnswer = first.replace(/#\d+#/, '');
          } else {
            multipleAnswer = answer.map(data => data.replace(/#\d+#/, ''));
          }
          groupId = key;
          if (this.groups[key]) {
            this.groups[key].push({
              site: -1,
              value: multipleAnswer,
            });
          } else {
            this.groups[key] = [{ site: -1, value: multipleAnswer }];
          }
        }
        if (isHollow) {
          inputIndex += 1;
        }
        return isHollow ? {
          isHollow: true,
          text: item,
          inputIndex,
          answer: multipleAnswer || answer,
          groupId,
          isAgain: !!this.exercise.isAgain,
          isRight: false,
          youAnswer: this.handlerUserAnswer(inputIndex),
        } : { isHollow: false, text: item };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .bq-container {
    height: calc(100% -50px);
    margin-top: 50px;
    padding: 0 20px;
    font-size: 18px;
    overflow-y: auto;
    .bq-wrap {
      margin-left: 10px;
      line-height: 2.4;
    }
    .explain {
      margin-left: 10px;
      line-height: 1.6;
    }
  }
</style>
